import { formatCurrency } from './format-currency.js';
/**
 * A movement amount with its direction as a leading sign, no space after it:
 * `+R1,750.00` money in, `-R15,900.00` money out, `R0.00` for zero.
 *
 * For amounts whose sign is the point (bank lines, a reconciliation
 * difference). A balance in ledger orientation reads `Cr` instead; use
 * `formatSignedBalance`.
 */
export function formatSignedCurrency(minorUnits, currency) {
    return `${minorUnits > 0 ? '+' : ''}${formatCurrency(minorUnits, currency)}`;
}
